import mdcTopAppBar from './mdc-top-app-bar.vue'
import mdcTopAppBarSection from './mdc-top-app-bar-section.vue'
import mdcTopAppBarActionItem from './mdc-top-app-bar-action-item.vue'
import mdcTopAppBarTitle from './mdc-top-app-bar-title.vue'
import vtTopAppBarFixedAjust from './vt-top-app-bar-fixed-ajust.vue'
export const mdcTopAppBarComponents = {
  mdcTopAppBar,
  mdcTopAppBarActionItem,
  mdcTopAppBarSection,
  mdcTopAppBarTitle,
  vtTopAppBarFixedAjust,
  // actionItem,
}